export default __webpack_public_path__ + "static/media/SNRWB_logo_czarne.7b93da14.png";